import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import {getCurrentLocale} from "@awe-web/shared/lib";
import {setLocale} from "@awe-web/shared/lib";
import {getLocales} from "@awe-web/shared/lib";

import "./language_switch.scss";

export default function LanguageSwitch({className}) {
  const dispatch = useDispatch();
  const locales = useSelector((state) => getLocales(state));
  const currentLocale = useSelector((state) => getCurrentLocale(state));
  const combinedClassName = classnames("language-switch", className);
  
  const onLocalChanged = useCallback((ln) => {
    dispatch(setLocale(ln));
  }, [dispatch]);

  const computeClassNames = useCallback((locale) => {
    const result = ["language-switch__button"];
    
    if (locale === currentLocale) {
      result.push("language-switch__button--active");
    }

    return result.join(' ');
  }, [currentLocale]);

  if (locales.length === 0) {
    return null;
  }

  return (
    <div className={combinedClassName}>
      {locales.map(locale => (
        <span key={locale.locale} className="language-switch__item">
          <button
            className={computeClassNames(locale.locale)}
            onClick={() => onLocalChanged(locale.locale)}>{locale.label}</button>
        </span>
      ))}
    </div>
  );
}
